import { Check, X } from "@phosphor-icons/react";
import { useRef } from "react";

import { Button } from "common/components/ui/Button";
import WorkspaceImage from "common/components/WorkspaceImage";
import useInvitationMutations from "common/datahooks/useInvitationMutations";
import type { Invitation } from "common/types";

export default function InvitationItem({
  invitation: { workspace_id, workspace_name, token },
}: {
  invitation: Invitation;
}) {
  const isAcceptRef = useRef<boolean>();

  const { respondToInvitation, isRespondingToInvitation } =
    useInvitationMutations();

  function acceptInvite() {
    isAcceptRef.current = true;
    respondToInvitation({ accept: true, memberToken: token });
  }

  function declineInvite() {
    isAcceptRef.current = false;
    respondToInvitation({ accept: false, memberToken: token });
  }

  return (
    <div className="mb-2 flex items-center gap-2 rounded-3xl border border-black-200 p-3 last:mb-0">
      <WorkspaceImage id={workspace_id} />
      <div className="flex flex-col items-start gap-y-0.5">
        <span className="text-md-bold">{workspace_name}</span>
      </div>
      <div className="ml-auto flex gap-2">
        <Button
          intent="iconOnly"
          size="sm"
          onClick={declineInvite}
          variant="outline-black"
          isLoading={isAcceptRef.current === false && isRespondingToInvitation}
          disabled={isAcceptRef.current === true && isRespondingToInvitation}
        >
          <X />
        </Button>
        <Button
          intent="iconOnly"
          variant="secondary-purple"
          size="sm"
          onClick={acceptInvite}
          isLoading={isAcceptRef.current === true && isRespondingToInvitation}
          disabled={isAcceptRef.current === false && isRespondingToInvitation}
        >
          <Check />
        </Button>
      </div>
    </div>
  );
}
